import styles from "./NavBar.module.css";
import Icon from "@mdi/react";
import {
	mdiViewDashboard,
	mdiMap,
	mdiInbox,
	mdiAccountMultiple,
	mdiAccountCircleOutline,
	mdiChevronDown,
	mdiLogout,
} from "@mdi/js";
import { Button, Menu, MenuItem } from "@mui/material";

// react
import React, { useState } from "react";
import { NavLink, Redirect } from "react-router-dom";

// tools
import Services from "tools/Services";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

const LOGO_URL = "https://cloudfront.private-radar.com/img/logo/logo_white.png";

export default function NavBar() {
	const { role, setRole } = useContext(MyContext);
	const [redirect, setRedirect] = useState(false);

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	// handles
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleClickLogout = () => {
		setAnchorEl(null);
		Services.clearToken();
		setRole(Role.Unauthorized);
		setRedirect(true);
	};

	return (
		<>
			{redirect && <Redirect to="/" />}
			<div className={styles.container}>
				<div className={styles.logoContainer}>
					<img src={LOGO_URL} alt="Logo" className={styles.logo} />
				</div>
				<nav>
					<ul className={styles.ul}>
						<li>
							<NavLink activeClassName={styles.isActive} to="/dashboard" className={styles.link}>
								<Icon className={styles.icon} path={mdiViewDashboard} size={2} />
								<div className={styles.name}>Dashboard</div>
							</NavLink>
						</li>
						<li>
							<NavLink activeClassName={styles.isActive} to="/roadmap" className={styles.link}>
								<Icon className={styles.icon} path={mdiMap} size={2} />
								<div className={styles.name}>Roadmap</div>
							</NavLink>
						</li>
						<li>
							<NavLink activeClassName={styles.isActive} to="/features" className={styles.link}>
								<Icon className={styles.icon} path={mdiInbox} size={2} />
								<div className={styles.name}>Features</div>
							</NavLink>
						</li>
						{role === Role.Admin && (
							<li className={styles.li}>
								<NavLink activeClassName={styles.isActive} to="/users" className={styles.link}>
									<Icon className={styles.icon} path={mdiAccountMultiple} size={2} />
									<div className={styles.name}>Users</div>
								</NavLink>
							</li>
						)}
					</ul>
				</nav>
				<div className={styles.logout}>
					<div>
						<Button
							id="basic-button"
							aria-controls={open ? "basic-menu" : undefined}
							aria-haspopup="true"
							aria-expanded={open ? "true" : undefined}
							onClick={handleClick}
						>
							<Icon path={mdiAccountCircleOutline} size={1.2} color="white" />
							<Icon path={mdiChevronDown} size={0.8} color="white" />
						</Button>
						<Menu
							id="account-menu"
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							disableScrollLock={true}
							PaperProps={{
								elevation: 0,
								sx: {
									overflow: "visible",
									filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
									mt: 1.5,
									"& .MuiAvatar-root": {
										width: 32,
										height: 32,
										ml: -0.5,
										mr: 1,
									},
									"&:before": {
										content: '""',
										display: "block",
										position: "absolute",
										top: 0,
										right: 14,
										width: 10,
										height: 10,
										bgcolor: "background.paper",
										transform: "translateY(-50%) rotate(45deg)",
										zIndex: 0,
									},
								},
							}}
							transformOrigin={{ horizontal: "right", vertical: "top" }}
							anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
						>
							{/* <MenuItem onClick={handleClose}>Profile TODO</MenuItem>
							<MenuItem onClick={handleClose}>My account TODO</MenuItem> */}
							<MenuItem onClick={handleClickLogout}>
								<div className={styles.logoutIcon}>
									<Icon path={mdiLogout} size={1} color="grey" />
									&#160;Logout
								</div>
							</MenuItem>
						</Menu>
					</div>
				</div>
			</div>
		</>
	);
}
